export default __webpack_public_path__ + "static/media/line-h-15.0936e48b.png";